import { useQuery } from '@tanstack/react-query';
import { opportunityService } from '../../../services/opportunityService';

export const candidateFitQueryKey = (
    opportunityId: number,
    positionId: number,
    page: number,
    pageSize: number,
    minFitScore: number,
    includeRejected: boolean,
) => ['opportunity', opportunityId, 'positions', positionId, 'candidates', { page, pageSize, minFitScore, includeRejected }];

export const useCandidateFitQuery = (
    opportunityId: number,
    positionId: number,
    page: number,
    pageSize: number,
    minFitScore: number,
    includeRejected: boolean,
) =>
    useQuery({
        queryKey: candidateFitQueryKey(opportunityId, positionId, page, pageSize, minFitScore, includeRejected),
        queryFn: () =>
            opportunityService.getCandidates(opportunityId, positionId, { page, pageSize, minFitScore, includeRejected }),
        staleTime: 5 * 60_000,  // scoring is heavy — cache 5 min
        enabled: opportunityId > 0 && positionId > 0,
    });
